import React from 'react'


export const TestimonialsSection = () => {
  return (
    <div>
        <section className="bg-gray-100 py-10">
  <div className="container mx-auto text-center">
    <h3 className="text-4xl font-bold mb-12">What Our Clients Say</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div className="bg-white p-6 mx-4 rounded-xl shadow-xl transform hover:scale-105 transition duration-500 lg:mx-0">
        <p className="text-lg text-gray-700 mb-4">
          "The care I received was exceptional. Highly recommend!"
        </p>
        <h4 className="text-xl font-semibold">John Doe</h4>
        <p className="text-gray-500">Recovered from Knee Surgery</p>
      </div>
      <div className="bg-white p-6 mx-4 rounded-xl shadow-xl transform hover:scale-105 transition duration-500 lg:mx-0">
        <p className="text-lg text-gray-700 mb-4">
          "I felt well-supported throughout my recovery. Amazing team!"
        </p>
        <h4 className="text-xl font-semibold">Jane Smith</h4>
        <p className="text-gray-500">Recovered from Back Injury</p>
      </div>
      <div className="bg-white p-6 mx-4 rounded-xl shadow-xl transform hover:scale-105 transition duration-500 lg:mx-0">
        <p className="text-lg text-gray-700 mb-4">
          "Top-notch care from start to finish. Couldn't be happier."
        </p>
        <h4 className="text-xl font-semibold">Michael Lee</h4>
        <p className="text-gray-500">Recovered from Sports Injury</p>
      </div>
    </div>
  </div>
</section>
    </div>
  )
}
